<template>
    <!--New Group-->
    <v-dialog
            v-model="dialog"
            max-width="290"
    >
        <template v-slot:activator="{ on }">
            <v-btn
                    :color="$store.state.color1"
                    dark
                    text
                    v-on="on"
            >
                <span class="hidden-xs-only">New</span>
                <v-icon class="pl-2">{{$store.state.icons.group}}</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-card-title>
                New Group
            </v-card-title>

            <v-card-text>
                <v-text-field
                        outlined
                        placeholder="New Group Name"
                        v-model="newgroupname"
                ></v-text-field>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                        text
                        @click="dialog = false"
                >
                    Cancel
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                        text
                        @click="creategroup()"
                >
                    Add
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import{
    mapState,
    mapActions
  } from 'vuex'
  export default {
    components: {},
    name: "NewGroup",
    data() {
      return {
        dialog:false,
        newgroupname:undefined
      }
    },
    computed:{
      ...mapState(['org'])
    },
    mounted() {
    },
    methods: {
      ...mapActions(['post','get']),
      creategroup: async function(){
        let body = {name: this.newgroupname}
        let res = await this.post({path:'api/groups/createv2',body:body});
        this.$store.commit('appendGroup',{name:res.name,sortkey:res.sortkey,groupkey:res.sortkey})
        this.newgroupname=undefined;
        this.dialog=false;
      }
    }
  }
</script>

<style scoped>

</style>